/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

import {register} from '@shopify/theme-sections';

register('collection-navbar', {
  onLoad() {
    // If collection URL has a sort parameter, set sort dropdown to matching value
    const currentUrl = new URL(window.location);
    const sortByParam = currentUrl.searchParams.get('sort_by');
    const sortOptions = Array.from(document.querySelectorAll('.sort__option'));

    if (sortByParam) {
      const sortOptionSelected = sortOptions.find(option => option.dataset.sortValue === sortByParam);
      if (sortOptionSelected) {
        sortOptionSelected.classList.add('sort__option--active')
      }
    } else {
      sortOptions[0].classList.add('sort__option--active');
    }

    // Toggle collection sort by options
    const sortContainer = document.querySelector('.collection-navbar__sort');
    if (sortContainer) {
      const sortToggle = sortContainer.querySelector('.sort__toggle');
      const sortList = sortContainer.querySelector('.sort__list');

      if (sortToggle && sortList) {
        let isSortActive = false;
        sortToggle.addEventListener('click', () => {
          sortList.classList.toggle('hide');
          sortContainer.classList.toggle('collection-navbar__sort--active');
          isSortActive = !isSortActive;
        });

        // Close sort by list when you click outside
        document.addEventListener('click', (event) => {
          if (!isSortActive) return;

          const isSortBy = Boolean(event.target.closest('.collection-navbar__sort'));
          if (isSortBy) return;

          sortList.classList.add('hide');
          sortContainer.classList.remove('collection-navbar__sort--active');
          isSortActive = false;
        });
      }
    }

    // Handle sort by option click
    if (sortOptions.length > 0) {
      sortOptions.forEach((sortOption) => {
        sortOption.addEventListener('click', (event) => {
          event.preventDefault();
          const sortValue = sortOption.dataset.sortValue;
          // const newUrl = new URL(window.location);
          if (sortValue === 'manual') {
            currentUrl.searchParams.delete('sort_by');
          } else {
            currentUrl.searchParams.set('sort_by', sortValue);
          }
          window.location = currentUrl;
        });
      });
    }

    // Toggle collection filters drawer
    const filterToggles = document.querySelectorAll('[data-collection-filter-toggle]');
    const filterDrawer = document.querySelector('.collection-filter__drawer');

    if (filterToggles.length > 0 && filterDrawer) {
      filterToggles.forEach((el) => {
        el.addEventListener('click', () => {
          const isHidden = filterDrawer.classList.contains('is-hidden');
          filterDrawer.setAttribute('aria-hidden', !isHidden);
          filterDrawer.classList.toggle('is-hidden');
          document.body.classList.toggle('filter-is-visible');
          el.classList.toggle('collection-filter__toggle--active');
        });
      });
    }

    // Layout switcher
    const layoutSwitchDefaultButton = document.querySelector('.layout-switch--default');
    const layoutSwitchAltButton = document.querySelector('.layout-switch--alt');
    const collectionGrid = document.querySelector('.collection-grid');

    if (layoutSwitchDefaultButton) {
      layoutSwitchDefaultButton.addEventListener('click', () => {
        collectionGrid.classList.add('collection-grid--default');
        collectionGrid.classList.remove('collection-grid--alt');
        layoutSwitchDefaultButton.setAttribute('disabled', 'disabled');
        layoutSwitchDefaultButton.setAttribute('aria-pressed', 'true');
        layoutSwitchDefaultButton.classList.add('layout-switch--selected');
        layoutSwitchAltButton.setAttribute('aria-pressed', 'false');
        layoutSwitchAltButton.removeAttribute('disabled');
        layoutSwitchAltButton.classList.remove('layout-switch--selected');
      });
      layoutSwitchAltButton.addEventListener('click', () => {
        collectionGrid.classList.add('collection-grid--alt');
        collectionGrid.classList.remove('collection-grid--default');
        layoutSwitchAltButton.setAttribute('disabled', 'disabled');
        layoutSwitchAltButton.setAttribute('aria-pressed', 'true');
        layoutSwitchAltButton.classList.add('layout-switch--selected');
        layoutSwitchDefaultButton.setAttribute('aria-pressed', 'false');
        layoutSwitchDefaultButton.removeAttribute('disabled');
        layoutSwitchDefaultButton.classList.remove('layout-switch--selected');
      });
    }
  },
});
